import { faReceipt, faHourglass2 } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { parseISO } from 'date-fns'
import { styled } from 'styled-components'

import {
  Countdown,
  useIsPast,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'
import type { ListingDtoStatusEnum } from '@b-stock/listing-api-client'

import { ViewCount } from '../ListingActionColumn/Bid/StatsBar'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  ${Typography.Body3}
  white-space: nowrap;
  color: ${Colors.Semantic.Neutral.dark_grey};
`

const Icon = styled(FontAwesomeIcon)`
  color: ${Colors.Semantic.Neutral.dark_grey};
  font-size: 1rem;
  height: 1rem;
`

export const OfferingInfo = ({
  itemsTotal,
  offerEndTime = '',
  status,
  viewCount,
}: {
  itemsTotal?: number
  offerEndTime?: string
  status: ListingDtoStatusEnum
  viewCount?: number
}) => {
  const isEnded = useIsPast(parseISO(offerEndTime)) || status === 'COMPLETED'

  return (
    <Container data-testid="offering-info-section">
      <Icon icon={faHourglass2} aria-label="Offer end time" />
      <>
        {status === 'CANCELED' ? (
          <FormattedMessage id="Listing.offeringDetails.timeLeft.canceled" />
        ) : (
          <>
            {!isEnded ? (
              <Countdown
                target={parseISO(offerEndTime)}
                format="short"
                data-testid="countdown"
              />
            ) : (
              <FormattedMessage id="Listing.offeringDetails.timeLeft.ended" />
            )}
          </>
        )}
      </>

      <ViewCount viewCount={viewCount} />

      {itemsTotal ? (
        <>
          <Icon icon={faReceipt} fontSize="1rem" />
          <span data-testid="items-total">{itemsTotal}</span>
        </>
      ) : null}
    </Container>
  )
}
